<template>
  <z-expansion-config-item 
    titulo="Impressão Térmica" 
    subtitulo="Ativa ou desativa a impressão térmica do sistema"
  >
    <v-switch
      v-model="store.configuracoes.APP_IMPRESSAO_TERMICA"
      :label="store.configuracoes.APP_IMPRESSAO_TERMICA ? 'Ativado' : 'Desativado'"
      left
      hide-details
      class="mt-0 pt-0 switch-reverse"
      @change="updateConfig"
    ></v-switch>
  </z-expansion-config-item>
</template>

<script setup>
import { getCurrentInstance } from 'vue';
import { useConfigStore } from '@/app/store/pinia/configuracoes'

const store = useConfigStore();

const { proxy } = getCurrentInstance();



async function updateConfig() {
  await store.salvarConfiguracao({
    config: 'APP_IMPRESSAO_TERMICA',
    valor: store.configuracoes.APP_IMPRESSAO_TERMICA,
    tipo: 'boolean',
    descricao: 'Impressão Térmica',
    ajuda: 'Ativa ou desativa a impressão térmica do sistema'
  });

  proxy.$store.dispatch("carregarConfiguracoes");
}

</script>

<style lang="scss" scoped>

.switch-reverse :deep(.v-input__slot) {
  flex-direction: row-reverse;

  label {
    width: 100px;
  }
}

</style>
